export function resolveTheme(mode, prefersDark) {
    if (mode === "system") {
        return prefersDark ? "dark" : "light";
    }
    return mode;
}
export function applyTheme(root, theme) {
    root.setAttribute("data-theme", theme);
}
//# sourceMappingURL=theme.js.map